<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="房间名称">
        <el-input v-model="form.roomName"></el-input>
      </el-form-item>
      <el-form-item label="老师ID">
        <el-input v-model="form.userUuid"></el-input>
      </el-form-item>
      <el-form-item label="老师昵称">
        <el-input v-model="form.userName"></el-input>
      </el-form-item>
      <el-form-item label="课程类型">
        <el-select v-model="form.roomType" placeholder="请选择课程类型">
          <el-option label="小课班" value=4></el-option>
          <el-option label="大课班" value=2></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="课程描述">
        <el-input v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="form.role" placeholder="请选择角色">
          <el-option label="老师" value=1></el-option>
          <el-option label="学生" value=2></el-option>
          <el-option label="助教" value=3></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">创建房间</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {createLive} from "@/api/live";

export default {
  data() {
    return {
      form: {
        description: "",
        role: "1",
        roomName: "",
        roomType: "4",
        userUuid: "",
        userName: "",
      }
    }
  },
  methods: {
    onSubmit() {
      const formData = {
        userUuid: this.form.userUuid,
        roomName: this.form.roomName,
        role: this.form.role,
        roomType: this.form.roomType,
        userName: this.form.userName,
        roomToken: "007eJxTYGD7/F3vwGnmiisy7RMOFMgdrYgO/bazRM1Ic8ZNxvT9FfYKDCZmhhYmSSbGlsnG5iaGBskWKYZpiWYGhsaGFhYGRoZG2lJemQJ8DAzMRsVfmBmYGBiBEMxnMDM2ZmVgYFBgMDJLSTFISUo2SzVOM0m2MDABmmRpYWFqamScYpZoZMoO1yTIEJSfnxufaGZsZmaZZp5obmkENoeRAQBaTykS",
        userToken: "",
        roomUuid: "Room_a63669f7a792",

      };
      // 将数据保存到 localStorage（或者 sessionStorage）
      localStorage.setItem('liveBroadcastData', JSON.stringify(formData));
      window.location.href = '/liveBroadcast.html';
      // this.$router.push({"path": "/liveLook"});
      // createLive(this.form).then(res => {
      //   if (res.code === 200) {
      //     const formData = {
      //       userUuid: this.form.userUuid,
      //       roomName: this.form.roomName,
      //       role: this.form.role,
      //       roomType: this.form.roomType,
      //       userName: this.form.userName,
      //       roomToken: "007eJxTYGD7/F3vwGnmiisy7RMOFMgdrYgO/bazRM1Ic8ZNxvT9FfYKDCZmhhYmSSbGlsnG5iaGBskWKYZpiWYGhsaGFhYGRoZG2lJemQJ8DAzMRsVfmBmYGBiBEMxnMDM2ZmVgYFBgMDJLSTFISUo2SzVOM0m2MDABmmRpYWFqamScYpZoZMoO1yTIEJSfnxufaGZsZmaZZp5obmkENoeRAQBaTykS",
      //       userToken: res.data.userToken,
      //       roomUuid: res.data.roomUuid,
      //
      //     };
      //     // 将数据保存到 localStorage（或者 sessionStorage）
      //     localStorage.setItem('liveBroadcastData', JSON.stringify(formData));
      //     // window.location.href = '/liveBroadcast.html';
      //     this.$router.push({"path": "/liveLook"});
      //   }
      // })
    }
  }
}
</script>

<style scoped>

</style>
